import type { FC } from "react";

import { cn } from "@/ui/lib";
import {
  TItemDescriptionProps,
} from "@/ui/components/data-display/Item/Item.config";
import { TextBody } from "../../typography/TextBody";

export const ItemDescription: FC<TItemDescriptionProps> = (
  {
    className,
    children,
  },
) => (
  <TextBody
    size={2}
    data-component="ItemDescription"
    className={cn(
      "text-foreground-muted-strong",
      className,
    )}
  >
    { children }
  </TextBody>
);

ItemDescription.displayName = "ItemDescription";
